import { PropsWithChildren, useMemo } from 'react'
import { Navigate, useParams } from 'react-router-dom'

import { TPermissionTypes } from '../../core/constants/menu'
import { useAppSelector } from '../../store'

type Props = {
  page: TPermissionTypes
  type?: 'view' | 'edit'
}

const ProtectedRoute: React.FC<PropsWithChildren<Props>> = ({
  page,
  children,
  type = 'view',
}) => {
  const { user } = useAppSelector((state) => state.app)
  const { festivalName, editionId } = useParams()
  const hasAccess = useMemo(() => {
    const festival = user?.festivalsPermissions.find(
      (o) => o.festivalName === festivalName,
    )

    if (user?.superAdmin) {
      return true
    }

    if (!festival) {
      return false
    }

    if (festival.permissions.some((o) => o.type === page && o[type])) {
      return true
    }

    return false
  }, [user?.festivalsPermissions, page, festivalName])

  return hasAccess ? <div key={editionId}>{children}</div> : <Navigate to="/" />
}

export default ProtectedRoute
